import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getAccountSelectedHistoryInfo } from "../../../modules/Account/accountSelectors";
import { useLocation } from "react-router";
import { useMemo } from "react";
import { MOBILE_HISTORY_INFO_TYPES } from "./mobileHistoryConstants";
import moment from "moment";

function MobileHistoryInfoHeader(props) {
    const {selectedHistoryInfo} = props;
    const location = useLocation();

    const date = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const type = searchParams.get('type');
        const currentTypeHistoryInfo = selectedHistoryInfo[type];
        if (!currentTypeHistoryInfo) return;
        switch (type) {
            case MOBILE_HISTORY_INFO_TYPES.POSITION:
                return currentTypeHistoryInfo.last_update_time || currentTypeHistoryInfo.open_time;
            case MOBILE_HISTORY_INFO_TYPES.TRANSACTION:
            default:
                return currentTypeHistoryInfo.created_at;
        }
    }, [location.search, selectedHistoryInfo]);

    const formattedDate = useMemo(() => date ? moment(date).format('D MMMM, HH:mm') : '', [date]);

    return <h4 className="f14 color-white-60 text-center fw400 mb-0">
        {formattedDate}
    </h4>
}

const mapStateToProps = createStructuredSelector({
    selectedHistoryInfo: getAccountSelectedHistoryInfo,
});

export default connect(mapStateToProps)(MobileHistoryInfoHeader);
